import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Plus } from "lucide-react";
import React from "react";

interface Props {
  form: React.ReactNode;
  title: string;
  description: string;
}
function PayItemDialogContainer({ form, title, description }: Props) {
  return (
    <Dialog>
      <DialogTrigger>
        <Button>
          <Plus />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>
        {form}
      </DialogContent>
    </Dialog>
  );
}

export default PayItemDialogContainer;
